import { StarBorder } from '@mui/icons-material'
import { Box, Button, Grid, Icon, IconButton, Rating, Tooltip, Typography } from '@mui/material'
import { Fragment, useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { BreadCrumb, DetailKeyValue, SnackSimple } from '../../../../../../components'
import { ActionDrawer } from '../../../../../../components/ActionDrawer'
import { BreadCrumbKeys, BreadcrumbTypes } from '../../../../../../components/breadCrumb/enum'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { DetailArticle } from '../../../../../../components/detailArticle'
import { DetailTypeOfResponse } from '../../../../../../components/detailTypeOfResponse'
import { HeaderQuestionnaire } from '../../../../../../components/headerQuestionnaire'
import { QuestionnaireProps } from '../../../../../../components/headerQuestionnaire/types'
import Loader from '../../../../../../components/loader'
import SimpleModal from '../../../../../../components/modal/simpleModal'
import { Resend } from '../../../../../../components/resend'
import StatusComponent from '../../../../../../components/status'
import { GlobalContext } from '../../../../../../contexts/Global'
import { useDetectBackButton } from '../../../../../../hooks/detectBackButton/useDetectBackButton'
import { useEvidences } from '../../../../../../hooks/evidences/useEvidences'
import { getStatus } from '../../../../../../hooks/status'
import { RequestErrors, Roles, Status, Types } from '../../../../../../utils/enums'
import { NavigatioStateType } from '../../../../../../utils/enums/navigatetionState'
import { icons } from '../../../../../../utils/icons'
import { handleAllErrors } from '../../../../../../utils/methods/handleErrors'
import EvidenceDetail from '../../../../../actionPlans/pages/form/components/evidenceDetail'
import { useEvidenceDownload } from '../../../../../calendar/pages/detail/hooks'
import { ConfigFolio, EvidencesConfig } from '../../typing'
import { reportFolioServices } from '../main/constants/states'
import { ApproveReason, ApproveRejectSolutionForm, ButtonsOption, GoBackToList, RejectReason, SimpleModalDetail } from './components'
import { Comment } from './components/comment'
import { EditFolio } from './components/menuOptions'
import { OptionSelected } from './components/optionSelected'
import { useGetData } from './hooks/useGetData'
import { useReportFoliosDetailContext } from './hooks/useReportFoliosContext'
import { useStyles } from './styles'
import { NewCard } from '../../../../../../components'
import { DaysTranscurredSla } from './components/DaysTranscurred'
import { ZoneInvolucratedCont, CategoryBox, QuestionnaryBox, TabSwitcher } from './components'
import { HistoryReportFolio } from './components/historial'
import { SendSolutionOrQuotation } from './components/sendSolutionOrQuotation'
import { HistoryType } from './enums/historyType'
import { SeeDetail } from './components/seeDetail'
import { HistoryStatus } from './enums/historyStatus'
import { VIEW_TYPES, ViewState } from './types/ViewTypes'
import { ConfirmModal } from '../main/components'
import dayjs from 'dayjs'
import { Constants } from '../../../../../../utils/constants'
import { FolioType } from '../../utils/enums/folioType'
import { TimesTypes } from '../../../../../../utils/enums/times'
import { reportFolioDetailMenuType } from './enums'
import { Priority } from '../../../../../../utils/enums/priority'
import { FolioTypeEndPoint } from '../../utils/enums/endpointFolioType'
import { InputModel } from '../../../../../../utils/types'
import { SeeOneDetail } from './components/seeOneDetailSolution'
import { DataSolutionOne } from './components/seeOneDetailSolution/types'


const Detail = () => {
  const location = useLocation()
  const { optionSelected, modal: modalContext, submitResendReport, userTracking, loadings, closeModal: closeModalContext, closeSnackbar: closeSnack, snackbar, setChangeReportFolio, setErrorsResend, errorsResend, unsubscribeUserFromTheFolio, ref, isUserAssigned } = useReportFoliosDetailContext()
  const { id } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { colors, state } = useContext(GlobalContext)
  const { role, id: currentUserId, isManagerOfDeparment } = state
  const [options, setOptions] = useState([
    { id: 1, label: t("reportFolio.buttons.quote"), value: "QUOTE", check: true },
    { id: 2, label: t("reportFolio.buttons.instructionComment"), value: "COMMENT", check: false },
    { id: 3, label: t("reportFolio.buttons.solution"), value: "SOLUTION", check: false },
  ]);
  const { data, loading, snackbarModal, setSnackbarModal, getData, getComments, getHistorial, isLoading, confirmModal, closeConfirmModal } = useGetData({ id, options })
  const { left, right, historial } = data
  const [seeTabs, setSeeTabs] = useState(true)
  const [seeDetail, setSeeDetail] = useState(true)
  const [historyData, setHistoryData] = useState<{ id?: number, type?: HistoryType, dateInit?: string, dateFinish?: string, provider?: string, status?: HistoryStatus, description?: string, }>()
  const [steps, setSteps] = useState(0)
  const [blockActions, setBlockActions] = useState<{
    menu: boolean;
    comment: boolean
    answer: boolean
    process: boolean
    goBack: boolean
  }>()
  const [headerScheduleDetail, setHeaderScheduleDetail] = useState<QuestionnaireProps>()
  const styles = useStyles({ color: colors })
  const { evidences, existEvidences, } = useEvidences({ evidencesResponse: data?.left?.evidences })
  const { disable, /* openSnackbar, handleCloseSnackbar, */ downloadEvidences, } = useEvidenceDownload('evidencias', data?.left?.evidences);
  const [addComment, setAddComment] = useState(false)
  const [raitingWasFailed, setRaitingWasFailed] = useState(false)
  const [raitingForce, setRaitingForce] = useState(false)
  const status = getStatus(left?.status?.id as Status, colors, t)

  const [modal, setModal] = useState({
    open: false,
    loading: false,
    data: {
      comment: '',
    },
    errors: {},
  })
  const resendReportForm = {
    sendCreatedBy: {
      label: `reportFolio.modal.sendReport.requestingUser`,
      name: 'sendCreatedBy',
      value: false,
      type: 'check',
      translate: true,
      wrapChildren: ({ children, id }) => {
        return (
          <Box sx={{ '& .MuiButtonBase-root': { padding: '4px' }, paddingLeft: '5px' }}>{children}</Box>
        )
      }
    },
    sendUserAssign: {
      label: `reportFolio.modal.sendReport.assignUser`,
      name: 'sendUserAssign',
      value: false,
      type: 'check',
      translate: true,
      wrapChildren: ({ children, id }) => {
        return (
          <Box sx={{ '& .MuiButtonBase-root': { padding: '4px' }, paddingLeft: '5px' }}>{children}</Box>
        )
      }
    },
    sendManageStore: {
      label: `reportFolio.modal.sendReport.agentStore`,
      name: 'sendManageStore',
      value: false,
      type: 'check',
      translate: true,
      wrapChildren: ({ children, id }) => {
        return (
          <Box sx={{ '& .MuiButtonBase-root': { padding: '4px' }, paddingLeft: '5px' }}>{children}</Box>
        )
      }
    },
  } as { [x: string]: InputModel }
  const listBreadCrumb = useMemo(() => {
    if (location.state?.type == NavigatioStateType.SCHEDULE) {
      return [
        {
          id: 'schedule',
          label: 'schedule',
          navigate: () => { navigate(`/dashboard/calendar`) }
        },
        {
          id: 'scheduleList',
          label: 'scheduleList',
          navigate: () => { navigate(`/dashboard/calendar/detail/${location.state?.id}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'reportFolioList',
          navigate: () => { navigate(`/dashboard/calendar/report-folio-list${location.search}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'detailReportFolio',
          navigate: () => { }
        },
      ]
    }
    if (location.state?.type == NavigatioStateType.USER_SCHEDULE) {
      return [
        {
          id: 'schedule',
          label: 'schedule-user',
          navigate: () => { navigate(`/dashboard/schedule-user`) }
        },
        {
          id: 'scheduleList',
          label: 'scheduleDetail',
          navigate: () => { navigate(`/dashboard/schedule-user/detail/${location.state?.id}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'reportFolioList',
          navigate: () => { navigate(`/dashboard/schedule-user/report-folio-list${location.search}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'detailReportFolio',
          navigate: () => { }
        },
      ]
    }
    return undefined
  }, [])
  const [respondReport, setRespondReport] = useState<EvidencesConfig[] | undefined>()
  const [evidencesDrawer, setEvidencesDrawer] = useState<{
    open: boolean
    type: {
      equivalence: string[]
      accept: string
    }
    name?: string
    value?: Record<
      string,
      {
        value?: Record<
          string,
          {
            progress?: boolean
            progressAmount?: string
            upload?: boolean
            name: string
            url: string | File
            ref?: any
          }
        >
        seeFiles?: boolean
        expanded?: boolean
        maxCount?: number
        size?: number
        accept?: string
        minAmount?: number
        typeEvidence?: Record<
          string,
          {
            isRequired?: boolean
            type: string
            amount: number
          }
        >
      }
    >
  }>({
    open: false,
    type: {
      equivalence: [],
      accept: '',
    },
  })
  const [showTabSwitcher, setShowTabSwitcher] = useState(true);
  const [currentView, setCurrentView] = useState<ViewState>({ type: '' });
  const [currentDataSolution, setCurrentDataSolution] = useState<DataSolutionOne | undefined>(undefined);
  const [isList, setIsList] = useState(true)

  const [values, setValues] = useState<Record<string, { value: null | string; label: string }>>({
    reason: {
      value: null,
      label: '',
    },
  })

  const openModal = () => {
    if ((!!raitingWasFailed) || left?.status?.id === Status.APPROVED) {
      setSteps(3)
      setRaitingWasFailed(true)
    }
    setModal((prev) => ({
      ...prev,
      open: true,
    }))
  }

  useEffect(() => {
    getHistorial(!!options[1].check, !!options[2].check);
  }, [id]);

  useEffect(() => {
    getHistorial(!!options[1].check, !!options[2].check);
  }, [options]);

  const hasApprovedOrRejectedQuote = (historial) => {
    if (!historial || !Array.isArray(historial.items)) {
      return false;
    }

    return historial.items[0]?.type === 'MANAGE_QUOTE' || historial.items[0]?.type === 'QUOTE' || (historial.items[0]?.type === 'REQUEST_QUOTES' && historial.items[0]?.requestSubmitted);

    /* return historial.items.some(item =>
      (item.type === 'REQUEST_QUOTES' && item.requestSubmitted) ||
      item.type === 'MANAGE_QUOTE'
    ); */
  };

  const closeSnackbar = () => {
    setSnackbarModal((prev) => ({
      ...prev,
      openSuuccess: false,
      open: false,
    }))
  }

  const closeModal = () => {
    setSteps(1)
    setModal((prev) => ({
      ...prev,
      open: false,
      loading: false,
    }))
    setEvidencesDrawer({
      open: false,
      type: {
        equivalence: [],
        accept: '',
      },
    })
  }

  const submitted = (resp: any) => {
    setChangeReportFolio(false)
    setAddComment(false)
    if (!resp?.errors) getComments()
  }

  const rejectReportFolio = ({ exitEvidence }: { exitEvidence: boolean }) => {
    if (!exitEvidence) {
      getReason()
    } else {
      setSteps(2)
    }
  }

  const getReason = (data?: {
    reason: string
    body: {
      evidences: {
        url: string
        originalname: string
        evidenceTypeId: number
      }[]
      comments: string[]
    }
  }) => {
    setChangeReportFolio(false)
    setModal((prev) => ({
      ...prev,
      loading: true,
    }))

    if (id) {
      let body: Record<string, boolean | string | string[] | {
        url: string;
        originalname: string;
        evidenceTypeId: number;
      }[]> = {
        isWeb: true,
        ...data?.body ?? {},
      }

      if (!!respondReport) {
        body = {
          ...body,
          ...data?.reason && { description: data?.reason },
        }
        reportFolioServices
          .answerReportFolio({ id: parseInt(id), body })
          .then((response) => {
            if (!response.errors) {
              setSnackbarModal((prev) => ({
                ...prev,
                message: t('reportFolio.detail.snackbar.responded.success'),
                type: Types.SUCCESS,
                openSuuccess: true,
              }))
              setRespondReport(undefined)
              setValues({
                reason: {
                  value: null,
                  label: '',
                },
              })
              setChangeReportFolio(false)
              setEvidencesDrawer({
                open: false,
                type: {
                  equivalence: [],
                  accept: '',
                },
              })
              closeModal()
            } else {
              if ([RequestErrors.ERR_ALREADY_ANSWERING, RequestErrors.ERR_ALREADY_ANSWERED].includes(response.errors[0].code)) {
                const message = handleAllErrors(response.errors[0].code, t, 'reportFolio.detail.snackbar.responded.error', { name: response.errors[0]?.data?.nameUserAnswering })
                const isAswered = RequestErrors.ERR_ALREADY_ANSWERED == response.errors[0].code
                setSnackbarModal((prev) => ({
                  ...prev,
                  message: `¡Lo sentimos! ${isAswered ? message : ''}`,
                  description: isAswered ? undefined : message,
                  type: Types.ERROR,
                  openSuuccess: true,
                  next: () => {
                    handleSuccess()
                    setRespondReport(undefined)
                    setValues({
                      reason: {
                        value: null,
                        label: '',
                      },
                    })
                    setEvidencesDrawer({
                      open: false,
                      type: {
                        equivalence: [],
                        accept: '',
                      },
                    })
                    setChangeReportFolio(false)
                    closeModal()
                    setSnackbarModal(prev => ({ ...prev, next: undefined, description: undefined, openSuuccess: false }))
                  }
                }))
              } else {
                setSnackbarModal((prev) => ({
                  ...prev,
                  message: handleAllErrors(response.errors[0].code, t, 'reportFolio.detail.snackbar.responded.error', { name: response.errors[0]?.data?.nameUserAnswering }),
                  type: Types.ERROR,
                  open: true,
                }))
              }
            }
          })
          .catch(() => {
            setSnackbarModal((prev) => ({
              ...prev,
              message: t('reportFolio.detail.snackbar.reject.error'),
              type: Types.ERROR,
              open: true,
            }))
          })
          .finally(() => {
            setModal((prev) => ({
              ...prev,
              loading: false,
            }))
          })
      } else {
        body = {
          ...body,
          reasonOfRejection: data?.reason || null,
        }
        reportFolioServices
          .rejectReportFolio({ id: parseInt(id), body })
          .then((response) => {
            if (!response.errors) {
              setSnackbarModal((prev) => ({
                ...prev,
                message: t('reportFolio.detail.snackbar.reject.success'),
                type: Types.SUCCESS,
                openSuuccess: true,
              }))
              setChangeReportFolio(false)
              closeModal()
              setValues({
                reason: {
                  value: null,
                  label: '',
                },
              })
              setEvidencesDrawer({
                open: false,
                type: {
                  equivalence: [],
                  accept: '',
                },
              })
              handleSuccess()
            } else {
              setSnackbarModal((prev) => ({
                ...prev,
                message: handleAllErrors(response.errors[0].code, t, 'reportFolio.detail.snackbar.reject.error'),
                type: Types.ERROR,
                open: true,
              }))
            }
          })
          .catch(() => {
            setSnackbarModal((prev) => ({
              ...prev,
              message: t('reportFolio.detail.snackbar.reject.error'),
              type: Types.ERROR,
              open: true,
            }))
          })
          .finally(() => {
            setModal((prev) => ({
              ...prev,
              loading: false,
            }))
          })
      }
    }
  }

  const showButton = () => {
    const raiting = left?.rating?.required && !left?.rating?.rating
    const statusResponded = left?.status?.id === Status.RESPONDED
    const statusRejected = left?.status?.id !== Status.REJECTED
    const statusAwaitSOLUTION = left?.status?.id !== Status.AWAIT_SOLUTION
    const existStoreAnswer = !!data?.right?.answers?.length
    const userId = left?.createBy.id

    let roleValidation = true
    if (role != Roles.ADMIN && userId != currentUserId && !data?.right?.canDoActions) {
      roleValidation = false
    }

    return (statusResponded || raiting) && existStoreAnswer && statusRejected && statusAwaitSOLUTION && roleValidation
  }

  const raiting = (data?: { rate: number | null; reason?: string }) => {
    if (id) {
      setModal((prev) => ({
        ...prev,
        loading: true,
      }))

      reportFolioServices
        .ratingReportFolio({ id: parseInt(id), body: { rating: data?.rate, ...(data?.reason ? { ratingComment: data?.reason } : {}) } })
        .then((response) => {
          if (!response?.errors) {
            setRaitingWasFailed(false)
            setSnackbarModal((prev) => ({
              ...prev,
              message: t(`reportFolio.detail.snackbar.${raitingWasFailed ? 'raiting' : 'approve'}.success`),
              type: Types.SUCCESS,
              openSuuccess: true,
            }))

            closeModal()
          } else {
            setSnackbarModal((prev) => ({
              ...prev,
              message: t('reportFolio.detail.snackbar.raiting.error'),
              type: Types.ERROR,
              open: true,
            }))
            setModal((prev) => ({
              ...prev,
              loading: false,
            }))
            setRaitingWasFailed(true)
          }
        })
        .catch(() => {
          setSnackbarModal((prev) => ({
            ...prev,
            message: t('reportFolio.detail.snackbar.raiting.error'),
            type: Types.ERROR,
            open: true,
          }))
          setModal((prev) => ({
            ...prev,
            loading: false,
          }))
        })
        .finally(() => {
          setModal((prev) => ({
            ...prev,
            open: false,
            loading: false,
          }))
        })
    }
  }

  const approve = async (data: {
    rate: number | null; reason?: string; goToRaiting?: boolean; body: {
      reason: string;
      body: {
        evidences: {
          url: string;
          originalname: string;
          evidenceTypeId: number;
        }[];
        comments: string[];
      };
    }
  }) => {
    setModal((prev) => ({
      ...prev,
      loading: true,
    }))

    if (!raitingWasFailed) {
      if (id) {
        const body = {
          "isWeb": true,
          "evidences": data.body?.body?.evidences || [],
          "comments": data.body?.body?.comments || [],
          "reasonOfApproval": data.body?.reason || null
        }
        const responseApprove = await reportFolioServices.approveReportFolio({ id: parseInt(id), body })

        if (!responseApprove.errors) {
          if (!!data && !!data?.rate && !data?.goToRaiting) {
            raiting(data)
          } else {
            setSnackbarModal((prev) => ({
              ...prev,
              message: t('reportFolio.detail.snackbar.approve.success'),
              type: Types.SUCCESS,
              open: true,
            }))
            setModal((prev) => ({
              ...prev,
              loading: false,
            }))
            if (left?.rating?.ratingQuestion) {
              setRaitingWasFailed(true)
              setSteps(3)
              setRaitingForce(true)
            } else {
              setSteps(0)
              setModal((prev) => ({
                ...prev,
                open: false,
                loading: false,
              }))

              setSnackbarModal((prev) => ({
                ...prev,
                message: t(`reportFolio.detail.snackbar.approve.success`),
                type: Types.SUCCESS,
                openSuuccess: true,
              }))
            }
          }
        } else {
          setSnackbarModal((prev) => ({
            ...prev,
            message: t('reportFolio.detail.snackbar.approve.error'),
            type: Types.ERROR,
            open: true,
          }))
          setModal((prev) => ({
            ...prev,
            loading: false,
          }))
        }
      }
    }
  }

  const approveFolio = async (data?: { rate: number | null; reason?: string; evidence?: boolean }) => {

    if (!data && left?.rating?.required) {
      setSteps(3)
    } else {
      if (id) {

        if (!!data) {
          if (data?.evidence) {
            setSteps(4)
          } else {
            approve(data)
          }
        } else {
          approve({ rate: 0, goToRaiting: true })
        }
      }
    }
  }

  const handleSuccess = () => {
    closeSnackbar()
    getData()
  }

  const handleSteps = () => {
    const itemsBySteps: { [x: number]: JSX.Element } = {
      1: (
        <ButtonsOption
          title={t('reportFolio.detail.buttonOptions.title')}
          reject={t('reportFolio.detail.general.reject')}
          approve={t('reportFolio.detail.general.approveAndReject')}
          approveFolio={() => { approveFolio({ evidence: !!left?.approverEvidence?.length || !!data?.left?.rating?.ratingQuestion }) }}
          rejectReportFolio={() => { rejectReportFolio({ exitEvidence: !!left?.rejectEvidence?.length }) }}
        />
      ),
      2:
        <RejectReason
          TypeConfig={ConfigFolio.REJECT}
          responded={!!respondReport}
          evidencesDrawer={evidencesDrawer}
          configReportFolio={right?.descriptionReject}
          setEvidencesDrawer={setEvidencesDrawer}
          value={values}
          setValue={setValues}
          evidencesConfig={!!respondReport ? respondReport : left?.rejectEvidence}
          folio={left?.folio} sendReason={getReason}
          title={!!respondReport ? t('reportFolio.detail.responded.title') : t('reportFolio.detail.reject.title')}
        />,
      4:
        <RejectReason
          TypeConfig={ConfigFolio.APPROVE}
          responded={!!respondReport}
          evidencesDrawer={evidencesDrawer}
          configReportFolio={right?.descriptionApprove}
          setEvidencesDrawer={setEvidencesDrawer}
          value={values}
          setValue={setValues}
          evidencesConfig={left?.approverEvidence}
          folio={left?.folio} sendReason={(data) => { approve({ body: data }) }}
          title={t('reportFolio.detail.approve.reason')}
        />,
      3: (
        <ApproveReason
          button={t('reportFolio.detail.general.send')}
          title={data?.left?.rating?.ratingQuestion ?? ''}
          sendReason={(data) => {
            if ((((left?.rating?.required) || (!raitingWasFailed)) && left?.status?.id !== Status.APPROVED) && !raitingForce) {
              approveFolio(data)
            } else {
              setChangeReportFolio(false)
              raiting(data)
            }
          }}
        />
      ),
    }

    return itemsBySteps[steps] ?? <></>
  }

  useDetectBackButton(unsubscribeUserFromTheFolio, isUserAssigned)

  const headerFronSchedule = () => {

    const state = location.state

    if ([NavigatioStateType.SCHEDULE, NavigatioStateType.USER_SCHEDULE, NavigatioStateType.SCHEDULE_RECURRENCE, NavigatioStateType.USER_RECURRENCE].includes(state?.type)) {
      setHeaderScheduleDetail({
        answerList: [{ label: state?.item ?? '' }],
        question: state?.question ?? '',
        title: state?.title ?? '',
        parentId: state?.parentId,
        version: state?.version,
      })
    }
  }

  const navigationActions = () => {
    const queary = new URLSearchParams(location.search)
    const actions = queary.get(BreadCrumbKeys.ACTIONS)
    setBlockActions({
      menu: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
      comment: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
      process: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
      answer: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
      goBack: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
    })
  }

  useLayoutEffect(() => {
    navigationActions()
    headerFronSchedule()
  }, [])

  const getColor = (priorityId: number) => {
    const colorMap: Record<number, string> = {
      [Priority.URGENT]: colors.color28,
      [Priority.HIGH]: colors.secondary,
      [Priority.MEDIUM]: colors.color8,
      [Priority.LOW]: colors.color10
    };
    return colorMap[priorityId] || colors.color10;
  };

  const folioTypeMap: Record<string, string> = {
    corrective: "Correctivo",
    preventive: "Preventivo",
  };

  const hideTabSwitcher = (viewType: string, itemId?: number,) => {
    setShowTabSwitcher(false);
    setCurrentView({
      type: viewType,
      itemId: itemId
    });
  };

  const showTabSwitcherForm = () => {
    setShowTabSwitcher(true);
    setCurrentView(VIEW_TYPES.TAB_SWITCHER);
  };

  const renderContent = () => {
    if (showTabSwitcher) {
      return (
        <TabSwitcher
          ComentariosComponent={
            <>
              <Comment
                addCommentBtn={{
                  onClick: () => {
                    setChangeReportFolio(true);
                    setAddComment(true);
                  },
                }}
                addComment={addComment}
                commentForm={{
                  id: id,
                  submitted: submitted,
                  hasComments: !!left?.comments?.length,
                  cancel: () => {
                    setChangeReportFolio(false);
                    setAddComment(false);
                  },
                }}
                comments={left?.comments}
              />
            </>
          }
          HistorialComponent={
            <>
              <Box>
                <HistoryReportFolio
                  onAttend={(viewType: string, itemId?: number) => hideTabSwitcher(viewType, itemId)}
                  historial={historial}
                  left={left}
                  isLoading={isLoading}
                  getHistorial={getHistorial}
                  options={options}
                  setOptions={setOptions}
                  setCurrentDataSolution={setCurrentDataSolution}
                  isList={isList}
                  setIsList={setIsList}
                />
              </Box>
            </>
          }
        />
      );
    }
    switch (currentView.type?.type || currentView?.type || currentView) {
      case VIEW_TYPES.SEND_SOLUTION:
        return <SendSolutionOrQuotation options={options} isComment={!!options[1].check} onAttend={showTabSwitcherForm} />;
      case VIEW_TYPES.DETAIL_QUOTE:
        return <SeeDetail
          quoteId={currentView.itemId}
          onAttend={showTabSwitcherForm}
          options={options}
        />
      case VIEW_TYPES.DETAIL_ONE_SOLUTIOM:
        return <SeeOneDetail
          data={currentDataSolution}
          onAttend={showTabSwitcherForm}
        />
      case VIEW_TYPES.SOLUTION_FORM:
        return <ApproveRejectSolutionForm
          type={currentView.type.action}
          onAttend={showTabSwitcherForm}
          list={historial.items[0].answers.length > 1}
        />;
      default:
        return null;
    }
  }

  return (
    <Box sx={styles.container} >

      <BreadCrumb
        removeBreadcrumb={['report-folio', 'calendar', 'schedule-user']}
        replaceLabels={{
          dashboard: 'maintenanceRequest',
          detailEdit: 'detailReportFolio'
        }}
        breadList={listBreadCrumb}
      />

      <NewCard>
        <Box sx={{ p: 3 }}>
          {
            !!loading && (
              <Box sx={styles.layerLoading}><Loader /></Box>
            )
          }
          {/* HEADER */}
          <>
            <Grid container spacing={3}>
              <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                <DaysTranscurredSla timeType={TimesTypes.SLA} finishDate={left?.timeSla?.dateFinishFolio ? dayjs(left?.timeSla.dateFinishFolio) : null} timeConfig={left?.timeSla?.timeConfig} startDate={dayjs(left?.timeSla?.dateCreateFolio)} endDate={dayjs(dayjs(left?.dateEnd).tz(left?.storeTimeZoneCode).locale('es').format(Constants.dayjsFormat3))} type={left?.type == 'preventive' ? FolioType.PREVENTIVE : FolioType.CORRECTIVE} title='SLA' isNull={!left?.timeSla?.timeConfig} />
              </Grid>
              <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                <DaysTranscurredSla datesArray={left?.timeOla?.rangeDates} timer={left?.timeOla?.activeTimer} timeType={TimesTypes.OLA} finishDate={null} timeConfig={left?.timeOla?.timeConfig} type={left?.type == 'preventive' ? FolioType.PREVENTIVE : FolioType.CORRECTIVE} title='OLA' isNull={!left?.timeOla?.timeConfig} />
              </Grid>
            </Grid>
            <Box sx={styles.headerSchedule}>
              {
                !!headerScheduleDetail && (
                  <HeaderQuestionnaire {...headerScheduleDetail} />
                )
              }
            </Box>
            <>
              {
                !blockActions?.goBack && (<GoBackToList exit />)
              }
            </>


          </>

          {/* Content */}
          <>
            <Box sx={[styles.header, styles.description]}>
              <>
              </>

              <Typography sx={{ color: "#4A01C4", fontWeight: 600, fontSize: "1.5rem" }}>{left?.folio}</Typography>

              {/* <DetailKeyValue
                name=''
                sxContainer={styles.folio}
                value={left?.folio}
                caption={t('reportFolio.detail.general.folioAmound')}
                captionChildren={(
                  <Box sx={styles.flex} className='gap'>
                    <Typography variant='text_grey' fontWeight='500' >{t('reportFolio.detail.general.folioAmound')}</Typography>

                    <Box sx={styles.status}>
                      <Typography variant='text_grey' sx={[styles[left?.priority?.id as Priority], styles.bgPriority]}>{left?.priority?.name}</Typography>

                      <PriorityStatus priority={left?.priority?.id as Priority} />
                    </Box>
                  </Box>
                )}
              /> */}

              <Box sx={styles.status}>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <StatusComponent
                    color={left?.type == FolioTypeEndPoint.PREVENTIVE ? colors.color40 : colors.primary}
                    msg={folioTypeMap[left?.type ?? ""] ?? "N/A"}
                    type='chip'
                    fit
                    size='xs'
                  />
                  <StatusComponent color={getColor(left?.priority.id ?? Priority.LOW)} msg={left?.priority.name ?? ''} type='chip' fit size='xs' />
                  <StatusComponent color={status.color} msg={left?.status?.id == Status.EXPIRED ? t('general.status.expiredFolio') : left?.status?.id == Status.NOT_FINISHED ? t('general.status.expidred_without_solution') : status.text} type='chip' fit size='xs' />
                </Box>

                {<ActionDrawer
                  title="EVIDENCIAS"
                  body={<>
                    <Box sx={styles.mainContainer}>
                      <Box sx={styles.bodyContainer}>
                        <EvidenceDetail
                          existEvidences={existEvidences}
                          evidences={{
                            image: evidences?.images,
                            comment: evidences?.comments,
                            documents: evidences?.documents,
                            video: evidences?.video,
                            sign: evidences?.sign
                          }}
                        />
                      </Box>
                      <Box>
                        <Button variant='text_primary_small' onClick={downloadEvidences} disabled={disable}>{t('schedule.buttons.downloadEvidence')}</Button>
                      </Box>
                    </Box>
                  </>}
                >
                  {({ openDrawer }) => <Tooltip title={t('general.seeEvidence')}><IconButton sx={{ marginLeft: '4px' }} disabled={!existEvidences} onClick={() => { if (existEvidences) { openDrawer() } }}>{icons('clip')}</IconButton></Tooltip>}
                </ActionDrawer>}

                {<EditFolio
                  reportUrl={right?.reportUrl}
                  lifeCicle={left?.status?.id}
                  data={data}
                  canReassignUser={![Status.REJECTED, Status.APPROVED].includes(left?.status?.id ?? 0) && !raitingWasFailed && (role == Roles.ADMIN || !!left?.canReassign || !!isManagerOfDeparment)}
                  hasApprovedOrRejected={!!data.right?.existAnyQuote/* hasApprovedOrRejectedQuote(historial) */}
                  existSolutionCaseMgDpto={!!data.right?.existSolutionCaseMgDpto}
                />}
              </Box>

            </Box>
            <Typography variant='h6' sx={{ fontSize: "16px", '&.MuiTypography-root': { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }, }}>{left?.title}</Typography>

            <Box sx={styles.description}>
              <Typography variant='footer' sx={{ fontSize: "14px", '&.MuiTypography-root': { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }, }}>{left?.description}</Typography>

              {/* <DetailKeyValue
                name=''
                sxContainer={styles.destail}
                value={t('reportFolio.detail.general.description')}
                caption={left?.description}
              /> */}

              {!!left?.reasonReassign.reason && (
                <DetailArticle
                  title=''
                  description={left?.reasonReassign.reason ?? ''}
                  footer={`${left?.reasonReassign.user} - ${left?.reasonReassign?.date}`}
                />
              )
              }

              {/* Question and list of answers */}

            </Box>

            {
              !!left?.reasonCancel.reason && (
                <Box sx={styles.description}>
                  <DetailArticle
                    title='Motivo de cancelación'
                    description={left?.reasonCancel.reason ?? ''}
                    footer={`${left?.reasonCancel.user} - ${left?.reasonCancel?.date}`}
                  />
                </Box>
              )
            }


            <Box sx={styles.content1}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <ZoneInvolucratedCont
                    titlePrincipal={t('reportFolio.detail.general.GestionZone')}
                    titleItem1={t('reportFolio.detail.general.area')}
                    captionitem1={left?.area ?? "N/A"}
                    titleItem2={t('reportFolio.detail.general.unitID')}
                    captionitem2={left?.unit ?? "N/A"}
                    titleItem3={t('reportFolio.detail.general.deparmentFull')}
                    captionitem3={left?.department ?? "N/A"}
                    titleitem4={left?.type === "preventive" ? t('reportFolio.detail.general.fechainifin') : null}
                    captionitem4={left?.type === "preventive" ? left?.dateStarteDateFinish : null}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ZoneInvolucratedCont
                    titlePrincipal={t('reportFolio.detail.general.Involucrated')}
                    titleItem1={t('reportFolio.detail.general.createrUser')}
                    captionitem1={left?.createBy?.user ?? 'N/A'}
                    titleItem2={t('reportFolio.dashboard.table.bossAssigned')}
                    captionitem2={left?.bossAssigned ?? 'N/A'}
                    titleItem3={t('reportFolio.detail.general.userAssigned')}
                    captionitem3={left?.UserAssign ?? 'No hay usuarios asignados.'}
                  />
                </Grid>
                <Grid item xs={12} md={(left?.answers || left?.assignedQuestionnaire) ? 6 : 12}>
                  <CategoryBox categories={left?.categories ?? []} flexColums={!left?.assignedQuestionnaire} />
                </Grid>
                {(left?.answers || left?.assignedQuestionnaire) &&
                  <Grid item xs={12} md={6}>
                    <QuestionnaryBox
                      titlePrincipal='Cuestionario'
                      titleItem1={left?.assignedQuestionnaire ? 'Nombre del cuestionario' : 'No aplica.'}
                      captionitem1={left?.assignedQuestionnaire ? left.questionarieName : 'No hay cuestionarios por mostrar.'}
                      captionitem2={left?.assignedQuestionnaire ? `${dayjs(left?.assignedQuestionnaire.dateStart).tz(left.storeTimeZoneCode).format(Constants.dayjsFormat)} - ${dayjs(left?.assignedQuestionnaire.dateEnd).tz(left.storeTimeZoneCode).format(Constants.dayjsFormat)}` : 'No aplica.'}
                      titleItem2={left?.assignedQuestionnaire ? t('reportFolio.detail.general.fechainifin') : undefined}
                    >
                      {left?.answers ? (
                        <>
                          <DetailKeyValue
                            name=''
                            sxContainer={styles.destail}
                            value={t('general.quizQuestion')}
                            caption={left.answers.question}
                          />
                          <DetailTypeOfResponse
                            answersList={left.answers.answersList ?? []}
                            type={left.answers.type}
                            fullAnswer={left.answers.fullAnswer}
                          />
                        </>
                      ) : null}
                    </QuestionnaryBox>

                  </Grid>
                }
              </Grid>


            </Box>

            {seeTabs ?
              <Box>
                <Box sx={styles.tabsContainer}>
                  <Box sx={[styles.comments]}>
                    {renderContent()}
                  </Box>
                </Box>
              </Box>
              :
              !seeDetail ?
                <SendSolutionOrQuotation options={options} id={historyData?.id} type={historyData?.type} setSeeTabs={setSeeTabs} />
                :
                <SeeDetail options={options} id={historyData?.id} type={historyData?.type} dateFinish={historyData?.dateFinish} dateInit={historyData?.dateInit} description={historyData?.description} provider={historyData?.provider} status={historyData?.status} setSeeTabs={setSeeTabs} />
            }

          </>

        </Box>
      </NewCard>



      <SimpleModalDetail />

      <SnackSimple
        close={() => {
          closeSnackbar()
        }}
        open={snackbarModal.open}
        type={snackbarModal.type}
        message={snackbarModal.message}
      />

      <SimpleModal
        removeClose
        open={snackbarModal.openSuuccess}
        description={snackbarModal.description ?? ""}
        close={() => {
          handleSuccess()
          if (snackbarModal?.cancel) { snackbarModal.cancel() }
        }}
        title={snackbarModal.message}
        buttonText={t(`general.${!!snackbarModal.cancel ? 'continue' : 'confirm'}`)}
        color={colors}
        cancelText={t('general.cancel')}
        back={snackbarModal.cancel}
        next={() => {
          if (snackbarModal?.next) {
            snackbarModal.next()
          } else {
            handleSuccess()
          }
        }}
      />

      {
        !!optionSelected && optionSelected.value.toString() == reportFolioDetailMenuType.RESEND_REPORT && (
          <Resend
            ref={ref}
            inputCustome={resendReportForm}
            close={closeModalContext}
            errorsResend={errorsResend}
            setErrorsResend={setErrorsResend}
            loading={!!loadings?.resend}
            open={!!modalContext?.open}
            send={({ data }) => { if (id) { submitResendReport({ data, id, }) } }}
            title={t('reportFolio.detail.general.resendReport')}
            twoButtons
          />
        )
      }

      <SnackSimple close={closeSnack} open={snackbar.open} type={snackbar.type} message={snackbar.message} />

      {
        !!optionSelected && <OptionSelected refresh={getData} data={data} />
      }

      <ConfirmModal
        open={confirmModal.open}
        title={confirmModal.title}
        description={confirmModal.description}
        onConfirm={confirmModal.onConfirm}
        onClose={
          () => {
            if (confirmModal.oncancel) {
              confirmModal.oncancel()
            } else {
              closeConfirmModal()
            }
          }
        }
        onClose={closeConfirmModal}
        onCancel={confirmModal.onCancel}
      />

    </Box >
  )
}

export { Detail }